module.exports = ".tags {\n  padding-left: 0; }\n  html.light-mode .tags {\n    color: #310b17; }\n  .tags li {\n    display: table-cell;\n    padding-right: 10px; }\n    .tags li a {\n      display: inline-block; }\n\n@media screen and (max-width: 768px) {\n  .tag {\n    font-size: 1.3rem; } }\n\n@media screen and (max-width: 568px) {\n  .tags {\n    list-style: none; }\n    .tags li {\n      display: inline; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/tags/tags.style.scss
// module id = 768
// module chunks = 2